import { definedNotNull } from '@df/common';
import { z } from 'zod';
const scheme = process.env.ENABLE_TLS === 'true' ? 's' : '';
const devApiUrl = `http${scheme}://localhost:${process.env.LISTEN_PORT_AUDIT_EXTERNAL ?? 8443}`;
const apiUrl = `${process.env.API_URL ?? devApiUrl}/`;
const appUrl = process.env.APP_URL ?? 'https://localhost:3000';
const appWsUrl = process.env.WS_API_URL ?? 'ws://localhost:9222';
const loginUrl = process.env.APP_URL
    ? `${process.env.APP_URL}/login`
    : 'https://localhost:3000/login';
const SYSTEM_ACCOUNT = 'ac0d1ff5-0000-4000-8000-000000000000';
const environmentSchema = z.enum(['development', 'testing', 'production']);
const environment = environmentSchema.parse(process.env.ENVIRONMENT);
const logLevels = ['None', 'Trace', 'Debug', 'Info', 'Warning', 'Error', 'Critical'];
const logLevelMap = new Map([
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ['None', { severity: 0, log: (...toLog) => { } }],
    ['Trace', { severity: 1, log: console.trace }],
    ['Debug', { severity: 2, log: console.debug }],
    ['Info', { severity: 3, log: console.info }],
    ['Warning', { severity: 4, log: console.warn }],
    ['Error', { severity: 5, log: console.error }],
    [
        'Critical',
        {
            severity: 6,
            log: (...toLog) => {
                console.error('[THIS IS A BUG]', ...toLog);
            },
        },
    ],
]);
const logLevelDecoder = (value) => z.enum(logLevels).optional().parse(value);
const undefinedToNoneMapper = (level) => definedNotNull(level) ? level : 'None';
const accountingDataLogLevel = undefinedToNoneMapper(logLevelDecoder(process.env.ACCOUNTING_DATA_LOG_LEVEL));
const logAfterResponseRawLevel = undefinedToNoneMapper(logLevelDecoder(process.env.ACCOUNTING_DATA_LOG_AFTER_RESPONSE_RAW_LEVEL));
const logAfterResponseErrorParsedLevel = undefinedToNoneMapper(logLevelDecoder(process.env.ACCOUNTING_DATA_LOG_AFTER_RESPONSE_ERROR_PARSED_LEVEL));
const logAfterResponseOkParsedLevel = undefinedToNoneMapper(logLevelDecoder(process.env.ACCOUNTING_DATA_LOG_AFTER_RESPONSE_OK_PARSED_LEVEL));
function leveledLog(level, ...toLog) {
    const envLogLevelData = logLevelMap.get(accountingDataLogLevel);
    const logLevelData = logLevelMap.get(level);
    if (!definedNotNull(envLogLevelData) ||
        !definedNotNull(logLevelData) ||
        accountingDataLogLevel === 'None' ||
        level === 'None' ||
        logLevelData.severity < envLogLevelData.severity) {
        return;
    }
    logLevelData.log(...toLog);
}
export { apiUrl, appUrl, appWsUrl, loginUrl, SYSTEM_ACCOUNT, environment, accountingDataLogLevel, logAfterResponseRawLevel, logAfterResponseErrorParsedLevel, logAfterResponseOkParsedLevel, leveledLog, };
